import { apiClient } from "../utils";

export const getFields = async (dataTypeId: string) => {
  const fieldsData = await apiClient({
    url: `/datatype/${dataTypeId}/field`,
    method: "GET",
  });
  return fieldsData;
};
